import { defineComponent as _defineComponent } from 'vue'
import VsBottomSheet from '@/components/vision/VsBottomSheet.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RightDrawer',
  props: {
    isVisible: { type: Boolean },
    isBottomDrawerVisible: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isVisible: boolean, isBottomDrawerVisible: boolean, fullWidth: boolean }



const transitionClass = computed(() => ({
  'side-drawer': true,
  'limit-max-width': !props.fullWidth,
}))

return { __sfc: true,props, transitionClass, VsBottomSheet }
}

})